<template>
  <div class="document-video-document">
    <!-- Video Dosyası Yükleme Alanı -->
    <div class="uploadOuter">
      <label class="btn btn-info" for="uploadVideoFile">
        <i class="uil-upload"></i> {{ $t("general.upload") }}
      </label>
      <strong>{{ $t("general.or") }}</strong>
      <span class="dragBox">
        <i :class="icon"></i>
        {{ $t("documents.video_document_drag_drop") }}
        <input 
          id="uploadVideoFile" 
          :accept="acceptableFileType" 
          draggable="true" 
          type="file" 
          @change="handleFileUpload"
          @dragenter="drag" 
          @dragleave="drop" 
          @dragover.prevent
        />
      </span>
    </div>

    <!-- Video önizleme ve ayarları (dosya yüklendikten sonra gösterilir) -->
    <div v-if="videoUrl">
      <video-type-selector 
        :value="isInteractiveVideoActive"
        @input="$emit('update:isInteractiveVideoActive', $event)"
        :first_text="$t('general.standard_video')"
        :second_text="$t('general.interactive_video')" 
      />

      <div v-show="isInteractiveVideoActive" class="interactive-video-area">
        <interactive-video-player-wrapper 
          :key="videoUrl" 
          :video-url="videoUrl" 
        />
      </div>

      <div v-show="!isInteractiveVideoActive" class="standart-video-area">
        <div class="video-preview">
          <div id="preview" v-html="videoDocInfo"></div>
          <video-player :key="videoUrl" :video-url="videoUrl" />
        </div>
        <div class="row">
          <span> 
            <label class="col-form-label" style="margin-left:2rem;margin-top:10px">
            {{ $t('general.fast_forward_video') }}
            </label>
          </span>
          <input 
            :checked="canBeFastForwarded"
            @change="handleFastForwardChange('start', $event.target.checked)"
            style="width:2%;margin-top:12px;margin-right:1rem;margin-left:1rem" 
            type="checkbox"
          >
          <span> 
            <label class="col-form-label" style="margin-left:2rem;margin-top:10px">
            {{ $t('general.fast_forward_when_video_completed') }}
            </label>
          </span>
          <input 
            :checked="canBeFastForwardedWhenCompleted"
            @change="handleFastForwardChange('completed', $event.target.checked)"
            style="width:2%;margin-top:12px;margin-right:1rem;margin-left:1rem" 
            type="checkbox"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoTypeSelector from "@/view/components/video/VideoTypeSelector.vue";
import InteractiveVideoPlayerWrapper from "@/view/components/video/interactive-video/InteractiveVideoPlayerWrapper.vue";
import VideoPlayer from "@/view/components/video/VideoPlayer.vue";

export default {
  name: "DocumentVideoDocument",
  components: {
    VideoTypeSelector,
    InteractiveVideoPlayerWrapper,
    VideoPlayer
  },
  props: {
    isInteractiveVideoActive: {
      type: Boolean,
      default: false
    },
    videoUrl: {
      type: String,
      default: ""
    },
    videoDocInfo: {
      type: String,
      default: ""
    },
    canBeFastForwarded: {
      type: Boolean,
      default: false
    },
    canBeFastForwardedWhenCompleted: {
      type: Boolean,
      default: false
    },
    acceptableFileType: {
      type: String,
      default: "video/*"
    },
    icon: {
      type: String,
      default: "uil-video"
    },
    existingFile: {
      type: String,
      default: null
    }
  },
  methods: {
    handleFastForwardChange(type, checked) {
      if (type === 'start' && checked) {
        this.$emit('update:canBeFastForwardedWhenCompleted', false);
      } else if (type === 'completed' && checked) {
        this.$emit('update:canBeFastForwarded', false);
      }
      
      if (type === 'start') {
        this.$emit('update:canBeFastForwarded', checked);
      } else {
        this.$emit('update:canBeFastForwardedWhenCompleted', checked);
      }
    },
    handleFileUpload(event) {
      let file = event.target.files[0];
      if (!file) return false;

      // Video dosyası mı kontrol et
      if (!this.compareTypeCompatibality(file, this.acceptableFileType)) {
        this.$emit('upload-error', this.$t('general.invalid_file_type'));
        return false;
      }

      // Parent component'e dosyayı gönder
      this.$emit('file-uploaded', file);
    },
    compareTypeCompatibality(file, acceptableType) {
      return (
        acceptableType.includes(file.type) ||
        acceptableType.includes(file.name.split(".").pop()) ||
        (acceptableType.split("/")[0] == file.type.split("/")[0] &&
          file.type.split("/")[0].toLowerCase() != "application")
      );
    },
    drag(event) {
      event.target.parentNode.className = "draging dragBox";
    },
    drop(event) {
      event.target.parentNode.className = "dragBox";
    }
  }
};
</script>

<style scoped>
.standart-video-area .artplayer-app {
  max-height: 500px;
}

.dragBox input[type="file"] {
  position: absolute;
  height: 100%;
  width: 100%;
  opacity: 0;
  top: 0;
  left: 0;
}

.dragBox {
  width: auto;
  padding: 0 10px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  transition: transform 0.3s;
}

.dragBox.draging {
  transform: scale(1.05);
  border-color: #3e416d;
}

.uploadOuter strong {
  padding: 0 10px;
}

.uploadOuter {
  text-align: center;
  padding: 20px;
}
</style>

